import { translations } from "i18n";
import { useState, useCallback, useEffect } from "react";
import Modal from "react-modal";

import styles from "./style.module.scss";
import GorgiasForm from "components/GorgiasForm";
import Collapsable from "./components/Collapsable";
// import SearchInput from "./components/SearchInput";
import StrapiClient from "StrapiClient";
import { MODAL_STYLES } from "data/constants";
import SpinnerOverlay from "components/SpinnerOverlay";
import Button from "components/Button";
import btnStyles from "components/Button/style.module.scss";

const FAQPage = () => {
  const [faqItems, setFaqItems] = useState([]);
  const [showLoader, setShowLoader] = useState(false);
  const [modalIsOpen, setModalIsOpen] = useState(false);
  const [searchString, setSearchString] = useState("");
  const [OpenCollapsKey, setOpenCollapsKey] = useState(null);

  useEffect(() => {
    setShowLoader(true);
    StrapiClient.getFaq().then((strapiResult) => {
      if (!strapiResult.error) {
        setFaqItems(strapiResult.response);
      }
      setShowLoader(false);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const searchFunc = ({ answer, question }) => {
    return (
      question.toLowerCase().includes(searchString.toLowerCase()) ||
      answer.toLowerCase().includes(searchString.toLowerCase())
    );
  };

  const handleSendPress = async () => {
    setModalIsOpen(true);
  };

  const closeModal = useCallback(() => {
    setModalIsOpen(false);
  }, []);

  const handleToggleCollaps = (key) => {
    setOpenCollapsKey(OpenCollapsKey === key ? null : key);
  };
  const searchResults = faqItems
    .filter(searchFunc)
    .map(({ answer, question, id }) => (
      <div style={{ margin: "10px" }}>
        <Collapsable
          key={id}
          title={question}
          content={answer}
          isOpen={OpenCollapsKey === id}
          onToggle={() => handleToggleCollaps(id)}
        />
      </div>
    ));

  return (
    <SpinnerOverlay showLoader={showLoader}>
      <Modal
        isOpen={modalIsOpen}
        onRequestClose={closeModal}
        style={MODAL_STYLES}
        ariaHideApp={false}
      >
        <div className={styles.formContainer}>
          <GorgiasForm isOpen={modalIsOpen} />
        </div>
      </Modal>
      <div className={styles.settingsContainer}>
        <div className={styles.headerContainer}>
          <h3>{translations("Faq.NeedHelp")}</h3>
          <Button
            classnames={[btnStyles.primary, btnStyles.medium]}
            onClick={handleSendPress}
            text={translations("Faq.ContactUs")}
          />
          {/* if the questions number increase please uncomment this */}
          {/* <SearchInput func={setSearchString} /> */}
        </div>
        {searchResults.length ? (
          searchResults
        ) : (
          <div className={styles.noSearchResults}>
            {translations("Faq.NoSearchResults")}
          </div>
        )}
      </div>
    </SpinnerOverlay>
  );
};

export default FAQPage;
